import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../styles/FontStyles';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioWhaleTail
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from '../Portfolio/Portfolio.styled';

import IconRocket from '../../assets/images/backoffice/willyImages/rocket.png';
import IconCoins from '../../assets/images/backoffice/willyImages/coins.png';
import IconPeople from '../../assets/images/backoffice/willyImages/people.png';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { formatUSD, walletsNFTWithdraw } from '../../helpers/helperFunctions';

import { BIG_WHALE, MY_TEAM, WEBINARS } from '../../routes/routes';

import Spinner from '../../components/common/Spinner';
import { getMyWebinarTickets } from './WebinarTickets.actions';
import { TicketItem } from './TicketItem';

export const TicketSummary = () => {
  const dispatch = useDispatch();

  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);

  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { loading, webinarTickets } = useAppSelector((state) => state.webinars);

  useEffect(() => {
    dispatch(getMyWebinarTickets());
  }, [dispatch]);

  return (
    <>
      <div style={{ marginBottom: 40 }}>
        <Flexed center between wrap>
          <H4>Webinar Tickets</H4>

          <Button
            negative
            maxWidth='350px'
            maxWidthSM='100%'
            onClick={() => history.push(WEBINARS)}>
            ADD WEBINAR TICKET
          </Button>
        </Flexed>

        <Collapsable expanded={expanded} elementHeight={height}>
          <div ref={ref}>
            {webinarTickets?.map((item: any, i: number) => (
              <TicketItem key={i} item={item} />
            ))}
          </div>
        </Collapsable>
      </div>
    </>
  );
};
